import i18n from '@dms/i18n';

import {VEHICLE_FORM_EVENTS} from '../../core/machine/constants/VEHICLE_FORM_EVENTS';
import {FluidReplacementServiceIntervals, RentalVehicle} from '../../core/types/RentalVehicle';
import {useVehicleFormContext} from '../hooks/useVehicleFormContext';
import {Field} from './primitives/Field';

interface LastFluidReplacementDatePickerProps {
  name: FluidReplacementServiceIntervals;
}

/**
 * Date picker component for selecting the last fluid replacement date of a vehicle component.
 * Used in service interval tracking to record when a fluid was last replaced.
 * Automatically calculates the next replacement date when changed.
 *
 * @param props.name - The fluid name (e.g., 'brakeFluid', 'coolantFluid')
 */
export function LastFluidReplacementDatePicker(props: LastFluidReplacementDatePickerProps) {
  const {sendMachineEvent} = useVehicleFormContext();

  const handleChange = (value: string | null) => {
    sendMachineEvent({
      type: VEHICLE_FORM_EVENTS.FLUID_REPLACEMENT_DATE_CHANGED,
      name: props.name,
      value,
    });
  };

  return (
    <Field<RentalVehicle>
      type="apiDate"
      name={`serviceIntervals.${props.name}.lastReplacementDate`}
      label={i18n.t('entity.vehicle.labels.dateOfLastReplacement')}
      onChange={handleChange}
    />
  );
}
